const messages = {
  login: 'Incorrect user or password, try again.',
};

export default messages;
